import {OrganizationThemeProvider} from "@/theming/OrganizationThemeProvider";
import {useOrganizationMetaData} from "@/data/app-data-hooks";
import {Redirect, Slot, useGlobalSearchParams} from "expo-router";
import {StatusBarMatcher} from "@/components/common/StatusBarMatcher";
import {useWebBodyBackground} from "@/hooks/useWebBodyBackground";
import {PaymentRequiredGate} from "@/components/membership/PaymentRequiredGate";

function OrganizationContent({orgId}: {orgId: string}) {
    useWebBodyBackground();

    return (
        <>
            <StatusBarMatcher/>
            <Slot/>
            <PaymentRequiredGate orgId={orgId}/>
        </>
    );
}

export default function OrganizationLayout() {
    const {orgId} = useGlobalSearchParams<{ orgId: string }>();
    const {data: organization} = useOrganizationMetaData(orgId);
    console.log(organization);

    return (
        <>
            {organization && <OrganizationThemeProvider key={orgId} organization={organization}>
                <OrganizationContent orgId={orgId!}/>
            </OrganizationThemeProvider>}
            {!organization && <Redirect href="/" />}
        </>
    );
}
